import { render, staticRenderFns } from "./QtyDiscountLink.vue?vue&type=template&id=a05afa58"
import script from "./QtyDiscountLink.vue?vue&type=script&lang=js"
export * from "./QtyDiscountLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports